import React, { useState, useEffect } from 'react'
import { api, formatCurrency, formatDate, formatStatus, getStatusBadgeClass } from '../../utils/api'

function OrderShipping() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadOrders()
  }, [])

  async function loadOrders() {
    setLoading(true)
    try {
      const response = await api.get('/api/warehouse/shipping')
      setOrders(response.orders || [])
    } catch (error) {
      console.error('Failed to load shipping orders:', error)
    } finally {
      setLoading(false)
    }
  }

  async function handleShip(orderId) {
    // In real implementation, this would open a modal for carrier/tracking
    const tracking = prompt('Enter tracking number:')
    if (!tracking) return

    try {
      await api.post(`/api/warehouse/shipping/${orderId}/ship`, {
        carrier: 'FedEx',
        tracking_number: tracking
      })
      loadOrders()
    } catch (error) {
      console.error('Failed to ship order:', error)
      alert(`Failed to ship order: ${error.message}`)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-12)' }}>
        <div className="loading-spinner" />
      </div>
    )
  }

  if (orders.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-title">No Orders to Ship</div>
        <div className="empty-state-description">
          All paid orders have been shipped.
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">Orders Ready to Ship</h2>
        <span className="badge badge-success">{orders.length} orders</span>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Customer</th>
            <th>Items</th>
            <th>Total</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <tr key={order.id}>
              <td style={{ fontWeight: 500 }}>{order.order_number}</td>
              <td>
                <div>{order.customer_name || '-'}</div>
                <div className="text-sm text-muted">{order.customer_email}</div>
              </td>
              <td>{order.item_count || 0}</td>
              <td>{formatCurrency(order.total)}</td>
              <td>
                <span className={`badge ${getStatusBadgeClass(order.status)}`}>
                  {formatStatus(order.status)}
                </span>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => handleShip(order.id)}
                >
                  Ship
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default OrderShipping
